import { useState } from "react";

import Cropper, { Area } from "react-easy-crop";
import Button from "components/atoms/buttons/Button";
import Modal from "components/atoms/modal";
import { getCroppedImage } from "./imageCropUtils";

type Props = {
  image: string;
  setImage: any;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
  format: string;
};

export default function CropperModal({ image, setImage, open, setOpen, format = "image/jpeg" }: Props) {
  const [croppedArea, setCroppedArea] = useState<Area>();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const onCropComplete = (croppedAreaPercentage: Area, croppedAreaPixels: Area) => {
    setCroppedArea(croppedAreaPixels);
  };

  // TODO:Need to add a loader for large images.
  const handleOnImageSelect = async () => {
    const croppedImage = await getCroppedImage(image, croppedArea, format);
    setImage(croppedImage);
    setOpen(false);
  };

  const handleModalOnClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleModalOnClose} closeOnOutsideClick={false}>
      <div className="relative flex h-[70vh] w-[50vw] items-center justify-center  bg-opacity-80">
        {/* <button type="button" className="absolute right-5 top-5" onClick={handleModalOnClose}>
          <XMarkIcon className="h-9 w-9 text-white" aria-hidden="true" />
        </button> */}
        <div className="h-full w-full">
          {image ? (
            <>
              <div className="relative h-full">
                <Cropper
                  image={image}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  minZoom={1}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                  showGrid={false}
                />
              </div>
              <input
                type="range"
                min="1"
                max="3"
                step="0.1"
                value={zoom}
                onChange={(e) => {
                  setZoom(Number(e.target.value));
                }}
                className="h-2 w-full cursor-pointer appearance-none rounded-lg bg-gray-200"
              />
            </>
          ) : null}
          <div className="flex items-end justify-end">
            <Button
              text="Select Image"
              onClick={handleOnImageSelect}
              variant="magnetiqSolid"
              additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
